import { Box, Grid, Typography } from "@mui/material";

import styles from "./styles";

const BENEFITS = [
  {
    icon: "💼",
    primary: "Appear more professional when reaching out to brands",
    secondary:
      "Bento sets up SPF, DKIM, and DMARC for you to improve email deliverability",
  },
  {
    icon: "🛠️",
    primary:
      "Significantly reduce the chance of getting blocked or marked as spam",
    secondary:
      "You maintain control to recover access, and Bento helps you detect and fix issues!",
  },
];

export default function CustomEmailBenefits() {
  return (
    <>
      {BENEFITS.map((benefit, index) => (
        <Grid container key={index} alignItems="center" sx={{ mb: 1 }}>
          <Grid
            container
            justifyContent="left"
            alignItems="center"
            item
            xs="auto"
          >
            <Box sx={styles.iconBlock}>{benefit.icon}</Box>
          </Grid>
          <Grid item xs md>
            <Typography>
              <strong>{benefit.primary}</strong>
            </Typography>
            <Typography>{benefit.secondary}</Typography>
          </Grid>
        </Grid>
      ))}
    </>
  );
}
